import React, { useState, useEffect } from "react";
import MainImg from "../../../assets/Dashboard/TestimonialTwo/homepage_search_method_by_browser_extension.webp";
import MainImg2 from "../../../assets/Dashboard/TestimonialTwo/homepage_search_method_by_domain.webp";
import MainImg3 from "../../../assets/Dashboard/TestimonialTwo/homepage_search_method_by_name.webp";
import MainImg4 from "../../../assets/Dashboard/TestimonialTwo/homepage_search_method_by_linkedin_id.webp";
import MainImg5 from "../../../assets/Dashboard/TestimonialTwo/homepage_search_method_by_decision_maker.webp";
import line2 from "../../../assets/line2.svg";
import UnderImg from "../../../assets/under.svg";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";

const slides = [
  {
    id: 1,
    img: MainImg3,
    text: "EMAIL FINDER BY",
    text2: "NAME",
    subtext:
      "Find verified email addresses with just a name and company domain. Our smart system checks multiple sources to give you accurate results you can count on. Connect with the right people, quickly and confidently.",
  },
  {
    id: 2,
    img: MainImg2,
    text: "EMAIL FINDER BY",
    text2: "DOMAIN",
    subtext:
      "Get all the email addresses at a company by entering their name or domain. Our system finds verified contacts across the organization, making it perfect for outreach and networking.",
  },
  {
    id: 3,
    img: MainImg5,
    text: "EMAIL FINDER BY ",
    text2: "DECISION MAKER",
    subtext:
      "Connect with key contacts in any organization. Enter a company name and job title, and we'll find verified emails for executives, managers, and other key decision-makers.",
  },
  {
    id: 4,
    img: MainImg4,
    text: "EMAIL FINDER BY",
    text2: "LINKEDIN ID",
    subtext:
      "Turn LinkedIn connections into direct contacts. Just paste a LinkedIn profile URL, and we'll find the person's verified email address. Connect directly with your LinkedIn network.",
  },
  {
    id: 5,
    img: MainImg,
    text: "BROWSER",
    text2: "EXTENSION",
    subtext:
      "Find emails while you browse. Our simple extension works right in your browser, so you can discover verified emails while looking at LinkedIn profiles or company websites without breaking your flow.",
  },
];

export default function TestimonialOne() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
      }, 4000);
      return () => clearInterval(interval);
    }
  }, [isPaused]);

  const togglePause = () => setIsPaused((prev) => !prev);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  return (
    <div
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      onClick={togglePause}
      className="relative overflow-hidden"
    >
      <button
        onClick={goToPrevious}
        className="absolute left-1 sm:left-4 top-1/2 transform -translate-y-1/2 text-3xl text-gray-600 hover:text-blue-600 z-10"
      >
        <FaAngleLeft />
      </button>
      <div
        className="flex transition-transform duration-500 ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className="w-full flex-shrink-0 bg-[#f4f8ff] px-8 flex flex-col md:flex-row md:items-center md:justify-between"
          >
            <div className="flex justify-center sm:px-20 sm:pb-4 items-center mt-8 md:mt-0 md:w-[45%] md:order-1 md:p-10">
              <img src={slide.img} alt="Dashboard preview" className="w-full" />
            </div>
            <div className="text-left md:text-center mt-10 md:mt-0 md:w-[55%] md:order-2 md:p-6">
              <h2 className="text-3xl sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold">
                {slide.text}{" "}
                <span className="relative inline-block">
                  {slide.text2}
                  <img
                    src={line2}
                    alt="Underline decoration"
                    className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
                  />
                </span>{" "}
              </h2>
              <p className="!text-base text-gray-600 md:text-lg my-6 whitespace-normal overflow-hidden truncate text-left">
                {slide.subtext}
              </p>
            </div>
          </div>
        ))}
      </div>
      <button
        onClick={goToNext}
        className="absolute right-1 sm:right-4 top-1/2 transform -translate-y-1/2 text-3xl text-gray-600 hover:text-blue-600 z-10"
      >
        <FaAngleRight />
      </button>
      <div>
        <img src={UnderImg} alt="Bottom decoration" className="w-full h-14" />
      </div>
    </div>
  );
}
